// document.addEventListener(
//     "DOMContentLoaded",
//     () => {
//         mmOpenCart();
//     },
//     { once: true }
// );


/**
 * Creates a debounced function that delays invoking func until after duration milliseconds have elapsed since the last time the debounced function was invoked.
 *
 * @param {Function} func - The function to debounce.
 * @param {number} duration - The number of milliseconds to delay.
 * @returns {Function} - The debounced function.
 */
function debounce(func, duration) {
    let timeout;
    return function (...args) {
        const effect = () => {
            timeout = null;
            return func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(effect, duration);
    };
}

/**
 * Get the cart section element from the DOM.
 *
 * @returns {HTMLElement} - The cart section element.
 */
function mmCartSectionElement() {
    return document.getElementById('shopify-section-mm-cart');
}

/**
 * Get the cart product container element from the cart section.
 *
 * @returns {HTMLElement} - The cart product container element.
 */
function mmCartProductsContainerElement() {
    return mmCartSectionElement().querySelector('.mm-dc-products-container');
}

/**
 * Get the cart item element for a specific product variant.
 *
 * @param {number} productVariantId - The product variant ID.
 * @returns {HTMLElement} - The cart item element.
 */
function mmCartItem(productVariantId) {
    return mmCartProductsContainerElement().querySelector(`[data-cart-item-id="${productVariantId}"]`);
}

/**
 * Get the cart item quantity element for a specific product variant.
 *
 * @param {number} productVariantId - The product variant ID.
 * @returns {HTMLElement} - The cart item quantity element.
 */
function mmCartItemQuantityEl(productVariantId) {
//   console.log(productVariantId);

    const itemEl = mmCartItem(productVariantId);
    if (!itemEl) {
      //location.reload();
      console.log('!itemEl', itemEl)
    }
    return itemEl.querySelector('[data-item-quantity]');
}

/**
 * Get the quantity of a specific cart item.
 *
 * @param {number} productVariantId - The product variant ID.
 * @returns {number} - The quantity of the cart item.
 */
function mmGetCartItemQuantity(productVariantId) {
  const quantityEl = mmCartItemQuantityEl(productVariantId);

  if (!quantityEl) {
      console.error(`Aucun élément trouvé pour le produit ${productVariantId}`);
      return 0;
  }

  return Number.parseInt(quantityEl.dataset.itemQuantity) || 0;
}


/**
 * Set the quantity of a specific cart item and update the DOM.
 *
 * @param {number} productVariantId - The product variant ID.
 * @param {number} newQuantity - The new quantity to set.
 */
function mmSetCartItemQuantity(productVariantId, newQuantity) {
  if (newQuantity >= 0) {
      const quantityEl = mmCartItemQuantityEl(productVariantId);
      if (quantityEl) {
          quantityEl.dataset.itemQuantity = newQuantity;
          quantityEl.innerText = newQuantity;
          
          // Gestion de l'affichage pour la quantité = 1
          const container = quantityEl.closest('.mm-dc-product-qqty');
          if (container) {
              if (newQuantity === 1) {
                  container.classList.add('mm-qtty-one');
              } else {
                  container.classList.remove('mm-qtty-one');
              }

              // Gestion de l'affichage des icônes minus/delete
              const deleteContainer = container.querySelector('.mm-pc-qtty-delete-container');
              const minusContainer = container.querySelector('.mm-pc-qtty-minus-container');
              if (deleteContainer && minusContainer) {
                  if (newQuantity === 1) {
                      deleteContainer.classList.remove('mm-none');
                      minusContainer.classList.add('mm-none');
                  } else {
                      deleteContainer.classList.add('mm-none');
                      minusContainer.classList.remove('mm-none');
                  }
              }
          }
      } else {
          console.error(`Impossible de trouver l'élément pour le produit ${productVariantId}`);
      }
  }
}

function mmSetFormItemQuantity(productVariantId, newQuantity) {
  // Display quantity in front
  if (newQuantity >= 0) {
      // Mettre à jour l'élément dans le panier si il existe
      const quantityEl = mmCartItemQuantityEl(productVariantId);
      if (quantityEl) {
          quantityEl.dataset.itemQuantity = newQuantity;
          quantityEl.innerText = newQuantity;
      }
  }
}


/**
 * Create a new cart element from the provided data.
 *
 * @param {Object} data - The data containing cart HTML.
 * @returns {HTMLElement} - The new cart element.
 */
function mmCartHTMLFromData(data) {
    const el = document.createElement('DIV');
    el.innerHTML = data.sections['mm-cart'];
    return el;
}

/**
 * Extract the items container from the new cart HTML.
 *
 * @param {Object} data - The data containing cart HTML.
 * @returns {HTMLElement} - The items container element.
 */
function extractItemsFromCartHTML(data) {
    const el = mmCartHTMLFromData(data);
    return el.querySelector('.mm-dc-products-container');
}

/**
 * Insert cart products from the response data into the current cart in the DOM.
 *
 * @param {Object} data - The data containing the new cart HTML.
 * @returns {Object} - The response data.
 **/
function insertCartProductsFromResponse(data) {
    const itemsContainer = extractItemsFromCartHTML(data);
    mmCartProductsContainerElement().innerHTML = itemsContainer.innerHTML;
    return data;
}

/**
 * Extract the total price element from the new cart HTML.
 *
 * @param {Object} data - The data containing the new cart HTML.
 * @returns {HTMLElement} - The total price element.
 */
function extractTotalPriceFromCartHTML(data) {
    const cartEl = mmCartHTMLFromData(data);
    return cartEl.querySelector('[data-cart-total-price]');
}

/**
 * Insert the total price from the response data into the current cart in the DOM.
 *
 * @param {Object} data - The data containing the new cart HTML.
 * @returns {Object} - The response data.
 */
function insertInsertTotalPriceFromResponse(data) {
    const newTotalPriceEl = extractTotalPriceFromCartHTML(data);
    const currentTotalPriceEl = mmCartSectionElement().querySelector('[data-cart-total-price]');
    currentTotalPriceEl.innerHTML = newTotalPriceEl.innerHTML;
    return data;
}

/**
 * Perform an API request to fetch or update cart data.
 *
 * @param {string} method - The HTTP method (GET, POST, etc.).
 * @param {string} path - The API endpoint path.
 * @param {Object} body - The request body data.
 * @returns {Promise<Object>} - A promise resolving to the response data.
 */
function mmAPIRequest(method, path, body) {
    document.querySelector('.mm-dc-products')?.classList?.add('mm-inactive');
    return fetch(window.Shopify.routes.root + path, {
        method: method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
    })
        .then((response) => response.json())
        .then((data) => {
            // mmLog(data);
            document.querySelector('.mm-dc-products')?.classList?.remove('mm-inactive');
            if (data.status && data.status > 400) {
                throw data;
            } else {
                return data;
            }
        });
}

/**
 * Fetch the current cart data.
 *
 * @returns {Promise<Object>} - A promise resolving to the cart data.
 */
function mmGetCart() {
    return mmAPIRequest('GET', 'cart.js');
}

/**
 * Open the cart drawer and fetch the latest cart data.
 */
function mmOpenCart() {
    mmGetCart()
        .then(refreshCartFromData)
        .then(() => {
            document.querySelector('.mm-drawer-cart-wrapper').classList.add('mm-dc-is-open');
            document.querySelector('.mm-drawer-cart-wrapper').style.zIndex = '999';
            document.querySelector('html').classList.add('stop-scrolling');
        });
}

/**
 * Open and refresh the cart drawer with the latest cart data.
 */
function mmOpenAndRefreshCart() {
    function handleResponse() {
        const newCartEl = document.createElement("DIV");
        newCartEl.innerHTML = this.responseText;
        const innerCart = mmCartSectionElement().querySelector(".mm-drawer-cart-wrapper");
        if (!innerCart) {
            console.error("Impossible de trouver le conteneur du panier");
            return;
        }
        innerCart.innerHTML = newCartEl.querySelector(".mm-drawer-cart-wrapper").innerHTML;

        // Ouvrir le panier
        // document.querySelector('.mm-drawer-cart-wrapper').classList.add('mm-dc-is-open');
        // document.querySelector('.mm-drawer-cart-wrapper').style.zIndex = '999';
        // document.querySelector('html').classList.add('stop-scrolling');
        
        // Mettre à jour le compteur du panier
        updateCartCount();
    }

    const request = new XMLHttpRequest();
    request.addEventListener("load", handleResponse);
    request.addEventListener("error", () => {
        console.error("Erreur lors du rafraîchissement du panier");
        alert("Une erreur est survenue lors du rafraîchissement du panier");
    });
    request.open("GET", "/?section_id=mm-cart", true);
    request.send();
}

/**
 * Close the cart drawer and allow page scrolling.
 */
function mmCloseCart() {
    hideBgFilter();
    const cartWrapper = document.querySelector('.mm-drawer-cart-wrapper');
    cartWrapper.classList.remove('mm-dc-is-open');
    document.querySelector('html').classList.remove('stop-scrolling');

    // Retirer le z-index de .mm-drawer-cart-wrapper après 2 secondes
    setTimeout(() => {
        cartWrapper.style.zIndex = '-1'; // Enlever le z-index
    }, 1000);
}


/**
 * Re-render the cart inner HTML from the response data and initialize Splide carousels.
 *
 * @param {Object} data - The data containing the new cart HTML.
 * @returns {Object} - The response data.
 */
function refreshCartFromData(data) {
    // Vérifier si data.sections existe et contient mm-cart
    if (!data.sections || !data.sections['mm-cart']) {
        console.warn('Les données de la section mm-cart sont manquantes dans la réponse');
        return data;
    }
    
    const newCartEl = document.createElement("DIV");
    newCartEl.innerHTML = data.sections["mm-cart"];
    
    const innerCart = mmCartSectionElement().querySelector(".mm-drawer-cart-wrapper");

    var showCrossSell = false;
    if (innerCart.querySelector('.mm-dc-left').classList.contains('mm-visible')) {
      showCrossSell = true;
    }

    // on chope tous nos accordeons
    // pour chaque accordeon, on regarde si il est actif
    // si oui, on regarde l'index de la boucle actuelle
    // on regarde dans le nouveau HTML, et on cherche l'accordéon ayant le meme index
    // on lui ajoute la class 'mm-active'
    let oldAccordeons = document.querySelectorAll(".mm-dc-products-container-aisle-accord");
    oldAccordeons.forEach((oldAccordeon, index) => {
      if(oldAccordeon.classList.contains('mm-active')){
        // newCartEl.querySelectorAll(".mm-dc-products-container-aisle-accord")[index].classList.add('mm-active');
      } else {
        newCartEl.querySelectorAll(".mm-dc-products-container-aisle-accord")[index].classList.remove('mm-active');
      }
    });

    // on recupere le scrollheight de la div des items
    const itemsContainer = document.querySelector('.mm-dc-products-container');
    const itemsContainerScrollHeight = itemsContainer ? itemsContainer.scrollTop : 0;

    // on recupere le scrollheight de la div du xsell
    const xsellContainer = document.querySelector('.mm-dc-cross-sell-container');
    const xsellContainerScrollHeight = xsellContainer ? xsellContainer.scrollTop : 0;

    // Remplace uniquement le contenu du panier
    if (innerCart) {
        innerCart.innerHTML = newCartEl.querySelector(".mm-drawer-cart-wrapper").innerHTML;
    }

    if(showCrossSell) {
      innerCart.querySelector('.mm-dc-left').classList.add('mm-visible');
      innerCart.querySelector('.mm-cart-cross-sell-filter').classList.add('mm-visible');
    }
    
    // on applique cette scrollheight sur le nouveau HTML
    const newItemsContainer = innerCart.querySelector('.mm-dc-products-container');
    if (newItemsContainer) {
        newItemsContainer.scrollTop = itemsContainerScrollHeight;
    }

    // on applique cette scrollheight sur le nouveau HTML
    const newXsellContainer = innerCart.querySelector('.mm-dc-cross-sell-container');
    if (newXsellContainer) {
        newXsellContainer.scrollTop = xsellContainerScrollHeight;
    }
    
    // Mise à jour de #CartPageForm
    const innerCartPageForm = document.querySelector("#CartPageForm");
    if (innerCartPageForm) {
        location.reload();
    }

    mmCartAccordeons();

    //reinitCartListeners();

    return data;
}

function mmDestroyLineItemFromCart(line_index) {

    mmAPIRequest("POST", "cart/change.js", {
        line: parseInt(line_index),
        quantity: 0,
        sections: "mm-cart",
    })
    .then(refreshCartFromData);
}

function updateQuantityDisplay(button, action) {
  const container = button.closest('.mm-dc-product-qqty');
  const quantityElement = container.querySelector('.mm-dc-product-qqty-number');
  let currentQuantity = parseInt(quantityElement.getAttribute('data-item-quantity')) || 0; // Utilise 0 si parseInt renvoie NaN
  
  if (action === 'increase') {
    currentQuantity++;
  } else if (action === 'decrease') {
    currentQuantity = Math.max(0, currentQuantity - 1);
  }
  
  // S'assurer que la valeur affichée est toujours un nombre valide
  const displayValue = isNaN(currentQuantity) ? 0 : currentQuantity;
  
  quantityElement.textContent = displayValue;
  quantityElement.setAttribute('data-item-quantity', displayValue);
  
  // Mise à jour des classes pour l'affichage des icônes
  if (currentQuantity === 1) {
    container.classList.add('mm-qtty-one');
  } else {
    container.classList.remove('mm-qtty-one');
  }
}

// Fonction pour gérer la diminution de la quantité avec un loader
function handleDecreaseQuantity(variantId, button) {
  console.log('ok')
  //button.classList.add('mm-loading');
  const itemCart = document.querySelector(`[data-cart-item-id="${variantId}"]`);
  const quantity = mmGetCartItemQuantity(variantId);
  const maxQtty = parseInt(itemCart.dataset.maxQuantity, 10);
  const newQuantity = quantity - 1;

  if (newQuantity > maxQtty) {
      return;
  }

  // Mise à jour visuelle immédiate
  mmSetCartItemQuantity(variantId, newQuantity);
  
  // Appel API avec debounce
  if(document.querySelector('#product-form')) {
      mmDebouncedPushNewQuantityFromForm(variantId, maxQtty);         
  } else {
      mmDebouncedPushNewQuantity(variantId, maxQtty);      
  }
}

// Fonction pour gérer l'augmentation de la quantité avec un loader
function handleIncreaseQuantity(variantId, button) {  // Ajout du paramètre button
  //button.classList.add('mm-loading');  // Utilisation du bouton passé en paramètre
  const itemCart = document.querySelector(`[data-cart-item-id="${variantId}"]`);
  const quantity = mmGetCartItemQuantity(variantId);
  const maxQtty = parseInt(itemCart.dataset.maxQuantity, 10);
  const newQuantity = quantity + 1;

  if (newQuantity > maxQtty) {
      return;
  }

  mmSetCartItemQuantity(variantId, newQuantity);
  
  if(document.querySelector('#product-form')) {
      mmDebouncedPushNewQuantityFromForm(variantId, maxQtty);         
  } else {
      mmDebouncedPushNewQuantity(variantId, maxQtty);      
  }
}

  // Fonction pour diminuer la quantité d'un produit
  function mmDecreaseProductQuantity(variantId) {
    const itemCart = document.querySelector(`[data-cart-item-id="${variantId}"]`); // Récupération de l'item card
    const quantity = mmGetCartItemQuantity(variantId); // Corrige l'utilisation de productVariantId -> variantId
    const maxQtty = parseInt(itemCart.dataset.maxQuantity, 10); // Récupération du max_quantity de l'item via le dataset
    const newQuantity = quantity - 1;

    if (newQuantity > maxQtty) {
        return;
    }

    mmSetCartItemQuantity(variantId, newQuantity);
    mmDebouncedPushNewQuantity(variantId, maxQtty);
  }
  function mmDecreaseProductQuantityFromForm(variantId) {
    const quantity = mmGetCartItemQuantity(variantId);
    const newQuantity = quantity - 1;

    if (newQuantity < 0) {
        return;
    }

    mmSetFormItemQuantity(variantId, newQuantity);
    mmDebouncedPushNewQuantityFromForm(variantId, 999);
    //updateAddToCartButton(variantId);
  }

  // Fonction pour augmenter la quantité d'un produit
  function mmIncreaseProductQuantity(variantId) {

    // console.log(variantId)

    const itemCart = document.querySelector(`[data-cart-item-id="${variantId}"]`); // Récupération de l'item card
    const quantity = mmGetCartItemQuantity(variantId); // Corrige l'utilisation de productVariantId -> variantId
    const maxQtty = parseInt(itemCart.dataset.maxQuantity, 10); // Récupération du max_quantity de l'item via le dataset
    const newQuantity = quantity + 1;

    if (newQuantity > maxQtty) {
        return;
    }
    mmSetCartItemQuantity(variantId, newQuantity);
    mmDebouncedPushNewQuantity(variantId, maxQtty);
  }
  function mmIncreaseProductQuantityFromForm(variantId) {

    // console.log(variantId)

    const itemCart = document.querySelector(`[data-cart-item-id="${variantId}"]`); // Récupération de l'item card
    const quantity = mmGetCartItemQuantity(variantId); // Corrige l'utilisation de productVariantId -> variantId
    const maxQtty = parseInt(itemCart.dataset.maxQuantity, 10); // Récupération du max_quantity de l'item via le dataset
    const newQuantity = quantity + 1;

    if (newQuantity > maxQtty) {
        return;
    }
    mmSetFormItemQuantity(variantId, newQuantity);
    mmDebouncedPushNewQuantityFromForm(variantId, maxQtty);
    //updateAddToCartButton(variantId);
  }

function reloadVariantSelector(selector = '.mm-reload') {
  const section = document.querySelector('.mm-main-product-grid');
  if (!section) {
    return
  }
  const sectionId = section.id;
  const currentUrl = new URL(window.location.href);
  currentUrl.searchParams.set('sections', sectionId);
  console.log('reloaded')

  fetch(currentUrl.toString())
    .then((response) => {
      if (!response.ok) {
        throw new Error(`Failed to fetch section ${sectionId}`);
      }
      return response.json();
    })
    .then((data) => {
      const newHtml = data[sectionId];
      if (!newHtml) {
        console.warn(`No HTML returned for section ${sectionId}`);
        return;
      }

      const tempDom = document.createElement('div');
      tempDom.innerHTML = newHtml;

      const newElements = tempDom.querySelectorAll(selector);
      const currentElements = document.querySelectorAll(selector);

      newElements.forEach((newEl, index) => {
        const currentEl = currentElements[index];
        if (currentEl) {
          currentEl.innerHTML = newEl.innerHTML;
        }
      });
    })
    .catch((error) => {
      console.error('Error reloading section from current product URL:', error);
    });
}

  // Fonction de rafraîchissement des cartes de produit
  function refreshProductCards(variantId, quantity) {
    const cards = document.querySelectorAll(`.mm-product-card-web[data-cart-item-id="${variantId}"]`);

    cards.forEach(function(card) {
      let quantitySelector = card.querySelector('.mm-dc-product-qqty-new');
      let CTA = card.querySelector('.mm-btn-add-product');
      let iconDelete = card.querySelector('.mm-icon-delete');
      let iconMinus = card.querySelector('.mm-icon-minus');
      let quantityNumber = quantitySelector.querySelector('.mm-dc-product-qqty-number');
      let quantityNumberIsInCart = card.querySelector('.mm-product-is-in-cart-quantity');

      if (quantity == 0) {
        quantitySelector.classList.add('mm-hidden');
        CTA.classList.remove('mm-hidden');
        card.classList.remove('mm-product-card-in-cart');
      } else if (quantity == 1) {
        quantitySelector.classList.remove('mm-hidden');
        quantitySelector.classList.add('mm-qtty-one');
        CTA.classList.add('mm-hidden');
        card.classList.add('mm-product-card-in-cart');
        quantityNumber.innerText = quantity;
        quantityNumberIsInCart.innerText = quantity;
      } else {
        quantitySelector.classList.remove('mm-hidden');
        quantitySelector.classList.remove('mm-qtty-one');
        CTA.classList.add('mm-hidden');
        card.classList.add('mm-product-card-in-cart');
        quantityNumber.innerText = quantity;
        quantityNumberIsInCart.innerText = quantity;
      }

      // Retirer le loader du CTA après le chargement
      CTA.classList.remove('mm-loading');
    });
  }


/**
 * Add a product to the cart and optionally open the cart drawer.
 *
 * @param {number} productId - The product ID to add.
 * @param {Object} options - Options for adding the product.
 * @param {number} [options.quantity=1] - The quantity to add.
 * @param {boolean} [options.openCart=true] - Whether to open the cart drawer after adding the product.
 */
function mmAddProductToCart(productId, { quantity = 1, openCart = true }) {

    mmAPIRequest('POST', 'cart/add.js', {
        items: [{ quantity: quantity, id: productId }],
        sections: 'mm-cart',
    })
        .then(mmAddOrRemoveFreeProducts)
        .then(refreshCartFromData)
        .then((data) => {
            if (openCart) {
                setTimeout(mmOpenCart);
            }
            refreshProductCards(productId, quantity);
            reloadVariantSelector();
            updateCartCount();
        })
        .catch((error) => {
            alert(error);
            mmOpenCart();
            console.log(error);
        });
}

function updateAddToCartButton(variantId) {
    const form = document.getElementById('product-form');
    if (!form) return;

    const ctaContainer = form.querySelector('.mm-product-form-component-cta');
    if (!ctaContainer) return;

    // Vérifier si le produit est dans le panier
    const isInCart = mmGetCartItemQuantity(variantId) > 0;

    // Mettre à jour le bouton d'ajout au panier
    const addToCartBtn = ctaContainer.querySelector('.mm-product-cta:not(.mm-pf-cta-item-in-cart)');
    const quantitySelector = ctaContainer.querySelector('.mm-pf-cta-item-in-cart');

    if (isInCart) {
        if (addToCartBtn) addToCartBtn.classList.add('hidden');
        if (quantitySelector) quantitySelector.classList.remove('hidden');
    } else {
        if (addToCartBtn) addToCartBtn.classList.remove('hidden');
        if (quantitySelector) quantitySelector.classList.add('hidden');
    }

    // Mettre à jour le sticky CTA
    const stickyCta = document.querySelector('.mm-product-sticky-cta');
    if (stickyCta) {
        if (isInCart) {
            stickyCta.classList.add('hidden');
        } else {
            stickyCta.classList.remove('hidden');
        }
    }
}

function refreshCTAComponent(variantId) {
    console.log('refreshCTAComponent appelé avec variantId:', variantId);
    
    const form = document.getElementById('product-form');
    if (!form) {
        console.log('Formulaire non trouvé');
        return;
    }

    const ctaContainer = form.querySelector('.mm-product-form-component-cta');
    if (!ctaContainer) {
        console.log('Conteneur CTA non trouvé');
        return;
    }

    // Vérifier si le produit est dans le panier
    const isInCart = mmGetCartItemQuantity(variantId) > 0;
    console.log('Produit dans le panier:', isInCart);

    // Mettre à jour le bouton d'ajout au panier
    const addToCartBtn = ctaContainer.querySelector('.mm-product-cta:not(.mm-pf-cta-item-in-cart)');
    let quantitySelector = ctaContainer.querySelector('.mm-pf-cta-item-in-cart');

    console.log('Bouton ajout au panier trouvé:', !!addToCartBtn);
    console.log('Sélecteur quantité trouvé:', !!quantitySelector);

    if (isInCart) {
        console.log('Mise à jour pour produit dans le panier');
        if (addToCartBtn) {
            addToCartBtn.classList.add('hidden');
            console.log('Bouton ajout au panier caché');
        }
        
        // Créer le sélecteur de quantité s'il n'existe pas
        if (!quantitySelector) {
            // Récupérer la quantité réelle du panier
            const actualQuantity = mmGetCartItemQuantity(variantId);
            const displayQuantity = actualQuantity > 0 ? actualQuantity : 1;
            
            quantitySelector = document.createElement('div');
            quantitySelector.className = 'mm-product-cta mm-btn mm-btn-primary mm-pf-cta-item-in-cart';
            quantitySelector.innerHTML = `
                <div class="mm-product-form-component mm-product-form-component-quantity mm-product-quantity">
                    <button type="button" class="decreaseBtn mm-qtty-btn" onclick="mmDecreaseProductQuantityFromForm(${variantId});" aria-label="Diminuer la quantité">
                        <span class="mm-pc-delete-icon mm-flex ${displayQuantity === 1 ? '' : 'mm-none'}">
                            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
                                <path d="M10.3267 5.99998L10.096 12M6.904 12L6.67333 5.99998M13.3187 3.85998C13.5467 3.89465 13.7733 3.93131 14 3.97065M13.3187 3.85998L12.6067 13.1153C12.5776 13.4921 12.4074 13.8441 12.13 14.1008C11.8527 14.3575 11.4886 14.5001 11.1107 14.5H5.88933C5.5114 14.5001 5.14735 14.3575 4.86999 14.1008C4.59262 13.8441 4.42239 13.4921 4.39333 13.1153L3.68133 3.85998M13.3187 3.85998C12.5492 3.74366 11.7758 3.65538 11 3.59531M3.68133 3.85998C3.45333 3.89398 3.22667 3.93065 3 3.96998M3.68133 3.85998C4.45076 3.74366 5.22416 3.65538 6 3.59531M11 3.59531V2.98465C11 2.19798 10.3933 1.54198 9.60667 1.51731C8.86908 1.49374 8.13092 1.49374 7.39333 1.51731C6.60667 1.54198 6 2.19865 6 2.98465V3.59531M11 3.59531C9.33581 3.4667 7.66419 3.4667 6 3.59531" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </span>
                        <span class="mm-pc-minus-icon mm-flex ${displayQuantity === 1 ? 'mm-none' : ''}">
                            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="16" viewBox="0 0 15 16" fill="none">
                                <line y1="8.00004" x2="15" y2="8.00004" stroke="white" stroke-width="1.66667"/>
                            </svg>
                        </span>
                    </button>
                    <input type="number" name="quantity-pf-${variantId}" id="quantity-pf-${variantId}" value="${displayQuantity}" class="mm-product-form-quantity-value" min="1" aria-label="Quantité" data-variant-id="${variantId}">
                    <button type="button" class="playBtn mm-qtty-btn" onclick="mmChangeQtty(1, 'quantity-pf-${variantId}'); mmIncreaseProductQuantityFromForm(${variantId})" aria-label="Augmenter la quantité" data-qtty-plus="quantity-pf-${variantId}">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <line x1="0.5" y1="7.99998" x2="15.5" y2="7.99998" stroke="white" stroke-width="1.66667"/>
                            <line x1="8.0013" y1="0.5" x2="8.0013" y2="15.5" stroke="white" stroke-width="1.66667"/>
                        </svg>
                    </button>
                </div>
            `;
            ctaContainer.appendChild(quantitySelector);
            console.log('Sélecteur de quantité créé et ajouté avec quantité:', displayQuantity);
        } else {
            // Si le sélecteur existe déjà, mettre à jour sa valeur
            const input = quantitySelector.querySelector(`#quantity-pf-${variantId}`);
            if (input) {
                const actualQuantity = mmGetCartItemQuantity(variantId);
                const displayQuantity = actualQuantity > 0 ? actualQuantity : 1;
                input.value = displayQuantity;
                
                // Mettre à jour l'affichage des icônes
                const deleteIcon = quantitySelector.querySelector('.mm-pc-delete-icon');
                const minusIcon = quantitySelector.querySelector('.mm-pc-minus-icon');
                
                if (deleteIcon && minusIcon) {
                    if (displayQuantity === 1) {
                        deleteIcon.classList.remove('mm-none');
                        minusIcon.classList.add('mm-none');
                    } else {
                        deleteIcon.classList.add('mm-none');
                        minusIcon.classList.remove('mm-none');
                    }
                }
            }
        }
        quantitySelector.classList.remove('hidden');
    } else {
        console.log('Mise à jour pour produit non dans le panier');
        if (addToCartBtn) {
            addToCartBtn.classList.remove('hidden');
            console.log('Bouton ajout au panier affiché');
        }
        if (quantitySelector) {
            quantitySelector.classList.add('hidden');
            console.log('Sélecteur quantité caché');
        }
    }

    // Mettre à jour le sticky CTA
    const stickyCta = document.querySelector('.mm-product-sticky-cta');
    if (stickyCta) {
        if (isInCart) {
            stickyCta.classList.add('hidden');
            console.log('Sticky CTA caché');
        } else {
            stickyCta.classList.remove('hidden');
            console.log('Sticky CTA affiché');
        }
    }
}

function mmAddProductToCartFromForm(productId, product_handle, { quantity = 1, openCart = true }) {
    console.log('mmAddProductToCartFromForm appelé avec productId:', productId);
    
    const section_id = document.querySelector('.shopify-section.mm-section-product').id;
    if(document.querySelector('.mm-pf-formats-container input:checked')) {
        quantity = document.querySelector('.mm-pf-formats-container input:checked').value;
    }

    mmAPIRequest('POST', 'cart/add.js', {
        items: [{ quantity: quantity, id: productId }],
        sections: 'mm-cart',
    })
    .then(mmAddOrRemoveFreeProducts)
    .then(refreshCartFromData)
    .then((data) => {
        console.log('Produit ajouté au panier, mise à jour de l\'interface');
        if (openCart) {
            setTimeout(mmOpenCart);
        }
        refreshProductCards(productId, quantity);
        updateCartCount();
        initializeStickyCTA();
        //refreshCTAComponent(productId);
    })
    .catch((error) => {
        alert(error);
        mmOpenCart();
        console.log(error);
    });
}

/**
 * Remove a specific product from the cart.
 *
 * @param {number} productVariantId - The product variant ID.
 */
function mmDestroyProductFromCart(productVariantId) {
    const newQuantity = 0;
    mmSetCartItemQuantity(productVariantId, newQuantity);
    mmDebouncedPushNewQuantity(productVariantId);
}

/**
 * Push the new quantity of a specific product to the server.
 *
 * @param {number} productVariantId - The product variant ID.
 */
function mmPushNewQuantity(productVariantId, quantity = '') {
  if (quantity === '') {
    quantity = mmGetCartItemQuantity(productVariantId);
  }

    // Ajouter les loaders sur les prix
    const totalPriceElement = document.querySelector(".mm-dc-price-title-6");
    const savingsPriceElement = document.querySelector(".mm-dc-price-title-4");
    const totalLoader = document.querySelector(".mm-dc-price-total .mm-loader-price");
    const savingsLoader = document.querySelector(".mm-dc-price-savings .mm-loader-price");
    if (totalPriceElement) {
      totalPriceElement.classList.add("mm-hidden");
	  }
    if (savingsPriceElement) {
      savingsPriceElement.classList.add("mm-hidden");
	  }
    if (totalLoader) {
      totalLoader.style.display = "block";
	  }
    if (savingsLoader) {
      savingsLoader.style.display = "block";
	  }

    mmAPIRequest('POST', 'cart/change.js', {
        id: productVariantId.toString(),
        quantity: quantity,
        sections: 'mm-cart',
    })
    .then(mmAddOrRemoveFreeProducts)
    .then(data => {
        // console.log("Réponse de l'API:", data);
        removeLoaderFromButton(productVariantId);
        refreshCartFromData(data);
        updateCartCount();

        // Retirer les loaders une fois les prix actualisés
        totalPriceElement.classList.remove("mm-hidden");
        savingsPriceElement.classList.remove("mm-hidden");
        totalLoader.style.display = "none";
        savingsLoader.style.display = "none";
      })


    refreshProductCards(productVariantId, quantity);
}
function mmPushNewQuantityFromForm(productVariantId, quantity = '') {

  const section_id = document.querySelector('.shopify-section.mm-section-product').id;
  const product_handle = document.querySelector('.mm-main-product-grid').dataset.handle;
  
  if (quantity === '') {
    quantity = mmGetCartItemQuantity(productVariantId);
  }

    // Ajouter les loaders sur les prix
    const totalPriceElement = document.querySelector(".mm-dc-price-title-6");
    const savingsPriceElement = document.querySelector(".mm-dc-price-title-4");
    const totalLoader = document.querySelector(".mm-dc-price-total .mm-loader-price");
    const savingsLoader = document.querySelector(".mm-dc-price-savings .mm-loader-price");
    if (totalPriceElement) {
      totalPriceElement.classList.add("mm-hidden");
	  }
    if (savingsPriceElement) {
      savingsPriceElement.classList.add("mm-hidden");
	  }
    if (totalLoader) {
      totalLoader.style.display = "block";
	  }
    if (savingsLoader) {
      savingsLoader.style.display = "block";
	  }

    mmAPIRequest('POST', 'cart/change.js', {
        id: productVariantId.toString(),
        quantity: quantity,
        sections: 'mm-cart',
    })
    .then(mmAddOrRemoveFreeProducts)
    .then(data => {
        refreshCartFromData(data);
        // Ne pas recharger la section pour éviter le flash, juste mettre à jour le CTA
          updateCartCount();
          reloadVariantSelector();
        //refreshCTAComponent(productVariantId);

        // Retirer les loaders une fois les prix actualisés
        totalPriceElement.classList.remove("mm-hidden");
        savingsPriceElement.classList.remove("mm-hidden");
        totalLoader.style.display = "none";
        savingsLoader.style.display = "none";
      })


    refreshProductCards(productVariantId, quantity);
}

function removeLoaderFromButton(variantId) {
    const buttons = document.querySelectorAll(`[data-cart-item-id="${variantId}"] button`);
    buttons.forEach((button) => {
        button.classList.remove('mm-loading');
    });
}
/**
 * Change a free product in the cart, replacing one variant with another.
 *
 * @param {number} productVariantIdToAdd - The product variant ID to add.
 * @param {number} productVariantIdToRemove - The product variant ID to remove.
 * @param {HTMLElement} clickedElem - The element that was clicked to trigger this action.
 */
function mmChangeFreeProductInCart(productVariantIdToAdd, productVariantIdToRemove, clickedElem) {
    // Debounce on the CTA
    clickedElem.innerText = 'AJOUTÉ !';
    clickedElem.classList.add('mm-disabled');

    mmAPIRequest('POST', 'cart/add.js', {
        items: [{ quantity: 1, id: productVariantIdToAdd }],
        sections: 'mm-cart',
    }).then(mmDestroyProductFromCart(productVariantIdToRemove));
}

/**
 * Debounced function to push new quantity of a specific product to the server.
 *
 * @param {number} productVariantId - The product variant ID.
 */
const mmDebouncedPushNewQuantity = debounce(function (variantId, maxQtty) {
    const quantity = mmGetCartItemQuantity(variantId);

    if (quantity > maxQtty) {
        return;
    }

    mmPushNewQuantity(variantId);
}, 300);

const mmDebouncedPushNewQuantityFromForm = debounce(function (variantId, maxQtty) {
    const quantity = mmGetCartItemQuantity(variantId);

    if (quantity > maxQtty) {
        return;
    }

    mmPushNewQuantityFromForm(variantId);
}, 300);

/**
 * Add or remove free products from the cart based on conditions.
 *
 * @param {Object} data - The data containing the new cart HTML.
 * @returns {Object} - The response data.
 */
function mmAddOrRemoveFreeProducts(data) {
    if (data.sections['mm-cart']) {
        const el = mmCartHTMLFromData(data);
        const freeProductEls = el.querySelector('[data-free-products]');
        let freeProductCounts = 0;

        // creates an object like { 44058675: 1, 44058001: 0 }
        // where key is free product id and value, its quantity
        const productsParams = Array.from(freeProductEls.children).reduce((param, freeProductEl) => {
            const productId = freeProductEl.dataset.variantId;
            const isFree = freeProductEl.dataset.freeProduct == 'true';
            const itemEl = mmCartItem(productId);
            if (isFree) {
                freeProductCounts += 1;
            }
            if (itemEl && isFree) {
                console.log('do nothing, item is already added');
                // do nothing, item is already added
            } else if (itemEl && !isFree) {
                console.log('item is present but should be removed');
                // item is present but should be removed
                param[productId] = 0;
            } else if (!itemEl && isFree) {
                console.log('item is absent but should be added', productId);
                // item is absent but should be added
                param[productId] = 1;
            } else {
                console.log('do nothing, item is not in cart and should not be');
            }
            return param;
        }, {});

        // Add or remove free products only if needed
        if (Object.keys(productsParams).length > 0) {
            mmAPIRequest('POST', 'cart/update.js', { updates: productsParams, sections: 'mm-cart' }).then(refreshCartFromData);
        }
    }
    return data;
}

/**
 * Add a free product to the cart and optionally open the cart drawer.
 *
 * @param {number} productId - The free product ID to add.
 * @param {Object} options - Options for adding the product.
 * @param {number} [options.quantity=1] - The quantity to add.
 * @param {boolean} [options.openCart=true] - Whether to open the cart drawer after adding the product.
 * @param {HTMLElement} clickedElem - The element that was clicked to trigger this action.
 */
function mmAddFreeProductToCart(productId, { quantity = 1, openCart = true }, clickedElem) {
    // Debounce on the CTA
    clickedElem.innerText = 'AJOUTÉ !';
    clickedElem.classList.add('mm-disabled');

    // Ajouter le free product
    mmAddProductToCart(productId, { openCart: false });
}

/**
 * Update the cart count bubble with the given value.
 *
 * @param {number} value - The new cart count value.
 */
function updateCartCount() {
    const value = parseInt(document.querySelector('.mm-drawer-cart .mm-dc-header').dataset.itemCount);
    if (value > 0) {
        document.querySelector('.mm-cart-count-bubble').classList.remove('mm-none');
        document.querySelector('.mm-cart-count-bubble').innerText = value;
    } else {
        document.querySelector('.mm-cart-count-bubble').classList.add('mm-none');
    }
}

window.addEventListener('DOMContentLoaded', (event) => {
    mmGetCart();
});

// Loader
function mmLoadThis(button) {
  button.classList.add('mm-loading');
}

function mmProductUpsellIn(inputElem, variantId, parentId) {
    if(inputElem.checked) {
      mmAddProductToCartWithProperty(variantId, parentId);
    } else {
      mmDestroyLineItemFromCart(inputElem.dataset.line);
    }
  }

  function mmCartShowCrossSell() {
    const filter = document.querySelector('.mm-cart-cross-sell-filter');
    filter.classList.add('mm-visible');

    const slideUp = document.querySelector('.mm-dc-left');
    slideUp.classList.add('mm-visible');
  }

  function mmCartHideCrossSell() {
    const filter = document.querySelector('.mm-cart-cross-sell-filter');
    filter.classList.remove('mm-visible');

    const slideUp = document.querySelector('.mm-dc-left');
    slideUp.classList.remove('mm-visible');
}

function mmRemoveLoader(clickedElem) {
  const CTA_container = clickedElem.closest('.mm-product-card-infos-bottom');
  const CTA = CTA_container.querySelector('.mm-btn-add-product');
  CTA.classList.remove('mm-loading');
}

// New form
/*********************************************************************************************
 * Sets up the cart form submission handler.
 */
function mmSetupProductForm() {
    const form = document.getElementById('product-form');
    if (!form) {
        return;
    }

    form.addEventListener("submit", function (event) {
        event.preventDefault();

        // Ajouter un loader sur le bouton
        const submitButton = form.querySelector('button[type="submit"]');
        if (submitButton) {
            submitButton.classList.add('mm-loading');
        }

        // Récupérer la variante sélectionnée
        const variantId = form.querySelector('#variant_id_input').value;
        if (!variantId) {
            return;
        }

        // Récupérer la quantité sélectionnée
        const formatOption = form.querySelector('input[name="format-option"]:checked');
        const quantity = formatOption ? parseInt(formatOption.value) : 1;

        // Récupérer le forfait de vente sélectionné
        const sellingPlanId = form.querySelector('input[name="selling_plan"]:checked')?.value;
        if (!sellingPlanId) {
            //alert("Veuillez sélectionner un forfait de vente");
            if (submitButton) {
                //submitButton.classList.remove('mm-loading');
            }
            //return;
        }

        const requestData = {
            items: [{
                id: variantId,
                quantity: quantity,
                //selling_plan: sellingPlanId
            }]
        };

        fetch("/cart/add.js", {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(requestData)
        })
            .then((response) => {
                if (!response.ok) {
                    return response.text().then(text => {
                        throw new Error(`Erreur lors de l'ajout au panier: ${text}`);
                    });
                }
                return response.json();
            })
            .then((data) => {
                // Mettre à jour le panier
                return mmGetCart().then(() => {
                    mmOpenAndRefreshCart();
                    // Rafraîchir uniquement la div du CTA
                    const section_id = document.querySelector('.shopify-section.mm-section-product').id;
                    const product_handle = document.querySelector('.mm-main-product-grid').dataset.handle;
                    renderShopifySection(section_id, product_handle, '.mm-product-form-component-cta');
                    updateCartCount();
                });
            })
            .catch((error) => {
                console.error("Erreur lors de l'ajout au panier:", error);
                alert("Une erreur est survenue lors de l'ajout au panier. Veuillez réessayer.");
            })
            .finally(() => {
                // Retirer le loader du bouton
                if (submitButton) {
                    submitButton.classList.remove('mm-loading');
                }
            });
    });
}

// Appeler la fonction au chargement de la page
document.addEventListener('DOMContentLoaded', function() {
    console.log("DOM chargé, initialisation du formulaire...");
    mmSetupProductForm();
});

//function reinitCartListeners() {
  //document.querySelectorAll('.mm-dc-product-qqty-minus').forEach(btn => {
    //btn.onclick = function() {
      //const variantId = ...; // récupère l'id depuis le DOM
      //handleDecreaseQuantity(variantId, btn);
    //}
  //});
  // Idem pour les boutons +, supprimer, etc.
//}